// src/lib/onboarding/should-enter-app.ts

export interface ShouldEnterAppInput {
  /** `profiles.onboarding_completed` — the full onboarding flow was finished. */
  onboardingCompleted: boolean;
  /** `profiles.onboarding_deferred` — the user soft-gated out via Save & Exit / Skip for now. */
  onboardingDeferred: boolean;
  /** A DB profile has actually loaded. Without it, completed/deferred can't be trusted. */
  hasProfile: boolean;
}

/**
 * Single source of truth for "may this user enter the app shell instead of being
 * routed into onboarding" — used by the `index.tsx` redirect guard.
 *
 * A deferred user (Save & Exit / Skip for now) is treated the same as a completed
 * one: they may enter the app. This is what fixes the soft-gate exit loop, where
 * `handleExit` routed to `/` but the guard only ever checked `onboarding_completed`
 * and bounced the user straight back into onboarding.
 */
export function shouldEnterApp({
  onboardingCompleted,
  onboardingDeferred,
  hasProfile,
}: ShouldEnterAppInput): boolean {
  if (!hasProfile) return false;
  return onboardingCompleted || onboardingDeferred;
}
